import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { RoomPriceRankMastInputZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelID"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

type QueryData = undefined;

export type ProductRoomPriceRankFormModel = AutoGeneratorForFormModel<
	RoomPriceRankMastInputZodSchemaType, //
	ExcludeKeys,
	QueryData
>;
